"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coverageToResume = exports.fixLimit = exports.productHasData = exports.coverageInfoForProduct = exports.limitForMaxValue = exports.limitsHaveRange = exports.specialCoverages = exports.endorsementCoverages = exports.deductibleCoverages = exports.regularCoverages = exports.fullDataForCode = void 0;
var ProductConfiguration_1 = require("../../models/ProductConfiguration");
// Constants
var coverageTypes_1 = require("../../constants/coverageTypes");
var specialCoverages_1 = require("../../constants/specialCoverages");
/**
 * Returns the complete coverage description for the provided code
 *
 * @param coverages - The coverage list
 * @param code - The code to look for
 */
function fullDataForCode(coverages, code) {
    return coverages.filter(function (coverage) { return coverage.code === code; }).pop();
}
exports.fullDataForCode = fullDataForCode;
function regularCoverages(coverages) {
    return coverages.filter(function (coverage) {
        return coverage.type.code !== coverageTypes_1.ENDORSEMENT_TYPE &&
            coverage.enableUI &&
            !Object.keys(specialCoverages_1.specialCoverageMap).includes(coverage.code);
    });
}
exports.regularCoverages = regularCoverages;
function deductibleCoverages(coverages) {
    return coverages.filter(function (coverage) {
        return coverage.type.code !== coverageTypes_1.ENDORSEMENT_TYPE &&
            coverage.enableUI &&
            coverage.applyDeductible;
    });
}
exports.deductibleCoverages = deductibleCoverages;
function endorsementCoverages(coverages) {
    return coverages.filter(function (coverage) { return coverage.type.code === coverageTypes_1.ENDORSEMENT_TYPE; });
}
exports.endorsementCoverages = endorsementCoverages;
/**
 * Returns a list of coverages that are categorized as "special".
 * Special coverages are basically entries that need to have an special treatment separate
 * from what it is defined in the data model. For now, only "assamovil" fits this description,
 * but the method has been defined as generic as possible to allow for future modifications
 *
 * @param coverages - The source coverage list
 */
function specialCoverages(coverages) {
    return coverages
        .filter(function (coverage) {
        return coverage.type.code !== coverageTypes_1.ENDORSEMENT_TYPE &&
            Object.keys(specialCoverages_1.specialCoverageMap).includes(coverage.code);
    })
        .map(function (coverage) { return specialCoverages_1.specialCoverageMap[coverage.code]; });
}
exports.specialCoverages = specialCoverages;
function limitsHaveRange(coverage) {
    if (coverage.limits.length <= 0) {
        return false;
    }
    var firstLimit = coverage.limits[0];
    return firstLimit.minimum !== firstLimit.maximum;
}
exports.limitsHaveRange = limitsHaveRange;
function limitForMaxValue(coverage, maxValue) {
    return coverage.limits
        .filter(function (curLimit) { return curLimit.maximum === maxValue; })
        .pop();
}
exports.limitForMaxValue = limitForMaxValue;
/**
 * Used to extract the coverages according to a specific product.
 * Will return empty arrays if nothing is found
 *
 * @param productCoverages - coverages for products in the store
 * @param product - the product to look for
 */
function coverageInfoForProduct(productCoverages, product) {
    if (Object.keys(productCoverages).includes(product)) {
        return productCoverages[product];
    }
    return {
        coverages: [],
        coverageResumes: [],
        configuration: ProductConfiguration_1.makeEmptyProductConfiguration(),
    };
}
exports.coverageInfoForProduct = coverageInfoForProduct;
/**
 * Will return true if the provided productCoverages instance contains information for the provided
 * product
 *
 * @param productCoverages - The product coverage instance to check
 * @param product - The product to look for
 */
function productHasData(productCoverages, product) {
    return Object.keys(productCoverages).includes(product);
}
exports.productHasData = productHasData;
/**
 * At the time of writing, the backend was returning "minimun" and "maximun" for
 * the coverage limits, instead of "minimum"/"maximum" (note the last letter).
 * This method auto maps the typo to the correct value, so that the rest of the
 * application is not affected.
 *
 * @param limit - The limit to fix
 */
function fixLimit(limit) {
    return __assign(__assign({}, limit), { minimum: typeof limit.minimun !== 'undefined' ? limit.minimun : limit.minimum, maximum: typeof limit.maximun !== 'undefined' ? limit.maximun : limit.maximum });
}
exports.fixLimit = fixLimit;
/**
 * Maps the provided coverage to a CoverageCatalogResume instance.
 *
 * @param coverage - The source coverage
 */
function coverageToResume(coverage) {
    return {
        code: coverage.code,
        type: coverage.type.code,
        applyDeductible: coverage.applyDeductible,
    };
}
exports.coverageToResume = coverageToResume;
//# sourceMappingURL=coverageCatalogMethods.js.map